import { PatientStatus, ReportType } from "@prisma/client";

export enum CustomField {
  Not,
  Cleaning,
  Emergency,
}

export type specialityOption = {
  value: string;
  label: string;
};

export const SpecialityOptions: Array<specialityOption> = [
  { value: "cosmetic", label: "Cosmetic Dentistry" },
  { value: "hygienist", label: "Dental Hygienist" },
  { value: "implant", label: "Dental Implants" },
  { value: "labor", label: "Dental Laboratory Technician" },
  { value: "dentistry", label: "Dentistry" },
  { value: "diabetics", label: "Dentistry For Diabetics" },
  { value: "denturist", label: "Denturist" },
  { value: "dermatology", label: "Dermatology" },
  { value: "endodontics", label: "Endodontics" },
  { value: "general", label: "General Dentistry" },
  { value: "orthodontics", label: "Orthodontics" },
  { value: "pediatric", label: "Pediatric Dentistry" },
  { value: "perio", label: "Periodontology" },
  { value: "prostho", label: "Prosthodontics" },
  { value: "sleep", label: "Sleep Dentistry" },
];

export const PatientStatusOptions = [
  { value: PatientStatus.NEW, label: "New Patient" },
  { value: PatientStatus.RETURNING, label: "Returning Patient" },
];

export const ReportTypeOptions = [{ value: ReportType.SLOT, label: "Open Appointment Slots" }];

export const AgeLimitOption = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

export const AvailabilityDateOptions = [
  { value: "weekday", label: "Weekday" },
  { value: "date", label: "Specific date" },
];

export const WeekDayOptions = [
  { value: 1, label: "Monday" },
  { value: 2, label: "Tuesday" },
  { value: 3, label: "Wednesday" },
  { value: 4, label: "Thursday" },
  { value: 5, label: "Friday" },
  { value: 6, label: "Saturday" },
  { value: 0, label: "Sunday" },
];

export const CountryOptions = [
  { value: "usa", label: "USA" },
  { value: "canada", label: "Canada" },
];

export const StateOptions = [
  { value: "al", label: "Alabama" },
  { value: "ak", label: "Alaska" },
  { value: "az", label: "Arizona" },
  { value: "ar", label: "Arkansas" },
  { value: "ca", label: "California" },
  { value: "co", label: "Colorado" },
  { value: "ct", label: "Connecticut" },
  { value: "de", label: "Delaware" },
  { value: "dc", label: "District of Columbia" },
  { value: "fl", label: "Florida" },
  { value: "ga", label: "Georgia" },
  { value: "hi", label: "Hawaii" },
  { value: "id", label: "Idaho" },
  { value: "il", label: "Illinois" },
  { value: "in", label: "Indiana" },
  { value: "ia", label: "Iowa" },
  { value: "ks", label: "Kansas" },
  { value: "ky", label: "Kentucky" },
  { value: "la", label: "Louisiana" },
  { value: "me", label: "Maine" },
  { value: "md", label: "Maryland" },
  { value: "ma", label: "Massachusetts" },
  { value: "mi", label: "Michigan" },
  { value: "mn", label: "Minnesota" },
  { value: "ms", label: "Mississippi" },
  { value: "mo", label: "Missouri" },
  { value: "mt", label: "Montana" },
  { value: "ne", label: "Nebraska" },
  { value: "nv", label: "Nevada" },
  { value: "nh", label: "New Hampshire" },
  { value: "nj", label: "New Jersey" },
  { value: "nm", label: "New Mexico" },
  { value: "ny", label: "New York" },
  { value: "nc", label: "North Carolina" },
  { value: "nd", label: "North Dakota" },
  { value: "oh", label: "Ohio" },
  { value: "ok", label: "Oklahoma" },
  { value: "or", label: "Oregon" },
  { value: "pa", label: "Pennsylvania" },
  { value: "ri", label: "Rhode Island" },
  { value: "sc", label: "South Carolina" },
  { value: "sd", label: "South Dakota" },
  { value: "tn", label: "Tennessee" },
  { value: "tx", label: "Texas" },
  { value: "ut", label: "Utah" },
  { value: "vt", label: "Vermont" },
  { value: "va", label: "Virginia" },
  { value: "wa", label: "Washington" },
  { value: "wv", label: "West Virginia" },
  { value: "wi", label: "Wisconsin" },
  { value: "wy", label: "Wyoming" },
  { value: "are", label: "Armed Forces Europe" },
  { value: "arp", label: "Armed Forces Pacific" },
  { value: "ara", label: "Armed Forces Americas" },
  { value: "as", label: "American Samoa" },
  { value: "fsm", label: "Federated States of Micronesia" },
  { value: "mar", label: "Marshall Islands" },
  { value: "mp", label: "Northern Mariana Islands" },
  { value: "pal", label: "Palau" },
  { value: "pr", label: "Puerto Rico" },
  { value: "vi", label: "Virgin Islands" },
  { value: "gu", label: "Guam" },
];

export const ProvinceOptions = [
  { value: "ab", label: "Alberta" },
  { value: "bc", label: "British Columbia" },
  { value: "mb", label: "Manitoba" },
  { value: "nb", label: "New Brunswick" },
  { value: "nl", label: "Newfoundland and Labrador" },
  { value: "ns", label: "Nova Scotia" },
  { value: "nt", label: "Northwest Territories" },
  { value: "nu", label: "Nunavut" },
  { value: "on", label: "Ontario" },
  { value: "pe", label: "Prince Edward Island" },
  { value: "qc", label: "Quebec" },
  { value: "sk", label: "Saskatchewan" },
  { value: "yt", label: "Yukon" },
];

export const ContactMethodOptions = [
  { value: "cellPhone", label: "Cell Phone" },
  { value: "workPhone", label: "Work Phone" },
  { value: "homePhone", label: "Home Phone" },
  { value: "email", label: "Email" },
  { value: "mail", label: "Mail" },
  { value: "sms", label: "Text Message" },
];

export const ContactTimeOptions = [
  { value: "morning", label: "Mornings" },
  { value: "afternoon", label: "Afternoons" },
  { value: "evening", label: "Evenings" },
];

export const VerticalPainAreaOptions = [
  { value: "no", label: "No" },
  { value: "up", label: "Upper" },
  { value: "down", label: "Lower" },
];

export const HorizontalPainAreaOptions = [
  { value: "no", label: "No" },
  { value: "left", label: "Left" },
  { value: "right", label: "Right" },
];

export const SymptomOptions = [
  { value: "sensitivity", label: "Hot and/or Cold Sensitivity" },
  { value: "throbbing", label: "Throbbing" },
  { value: "other", label: "Other" },
];

type PaymentOption = {
  paymentType: string;
  label: string;
  value: string;
};

export const InsuranceOptions: Array<PaymentOption> = [
  { value: "aetna", label: "Aetna", paymentType: "insurance" },
  { value: "aflac", label: "AFLAC", paymentType: "insurance" },
  { value: "alaska", label: "Alaska Carpenters**", paymentType: "insurance" },
  { value: "amc", label: "Allied Metal Crafts", paymentType: "insurance" },
  { value: "always", label: "ALWAYS CARE BENEFITS", paymentType: "insurance" },
  { value: "ameriben", label: "AmeriBen", paymentType: "insurance" },
  { value: "achp", label: "America's Choice Health Plan", paymentType: "insurance" },
  { value: "ameritas", label: "Ameritas", paymentType: "insurance" },
  { value: "anthem", label: "Anthem BCBS", paymentType: "insurance" },
  { value: "apwu", label: "APWU HEALTH PLAN", paymentType: "insurance" },
  { value: "assurant", label: "Assurant health", paymentType: "insurance" },
  { value: "avesis", label: "Avesis", paymentType: "insurance" },
  { value: "axis", label: "AXIS INSURANCE COMPANY", paymentType: "insurance" },
  { value: "bcbs", label: "BCBS", paymentType: "insurance" },
  { value: "beam", label: "Beam Dental", paymentType: "insurance" },
  { value: "bas", label: "Benefit Administrative Systems, LLC", paymentType: "insurance" },
  { value: "benefit", label: "BENEFIT SOLUTIONS", paymentType: "insurance" },
  { value: "best", label: "BEST LIFE", paymentType: "insurance" },
  { value: "carrington", label: "Carrington plan", paymentType: "insurance" },
  { value: "cas", label: "CAS (Coastal Administrative Services)", paymentType: "insurance" },
  { value: "cherokee", label: "Cherokee Insurance", paymentType: "insurance" },
  { value: "chesapeake", label: "CHESAPEAKE", paymentType: "insurance" },
  { value: "cigna", label: "Cigna", paymentType: "insurance" },
  { value: "denta", label: "Dentaquest", paymentType: "insurance" },
  { value: "delta", label: "Delta Dental", paymentType: "insurance" },
  { value: "select", label: "DENTAL SELECT", paymentType: "insurance" },
  { value: "dentegra", label: "Dentegra", paymentType: "insurance" },
  { value: "fce", label: "FCE Benefit Administrator", paymentType: "insurance" },
  { value: "fep", label: "FEP BLUE DENTAL", paymentType: "insurance" },
  { value: "first", label: "First Choice", paymentType: "insurance" },
  { value: "gena", label: "GEHA", paymentType: "insurance" },
  { value: "group", label: "Group Health", paymentType: "insurance" },
  { value: "guardian", label: "Guardian", paymentType: "insurance" },
  { value: "welfare", label: "Health & Welfare Plan", paymentType: "insurance" },
  { value: "hca", label: "HEALTH COMP ADMINISTRATORS", paymentType: "insurance" },
  { value: "hpartner", label: "HEALTH PARTNERS", paymentType: "insurance" },
  { value: "hplex", label: "HEALTH PLEX", paymentType: "insurance" },
  { value: "hma", label: "HMA Dental", paymentType: "insurance" },
  { value: "hmsa", label: "HMSA", paymentType: "insurance" },
  { value: "humana", label: "HUMANA", paymentType: "insurance" },
  { value: "ihc", label: "IHC HEALTH SOLUTIONS", paymentType: "insurance" },
  { value: "ilwu", label: "ILWU-PMA Benefit Plans Office", paymentType: "insurance" },
  { value: "iaic", label: "Independence American Insurance Company", paymentType: "insurance" },
  { value: "kaiser", label: "Kaiser Permanente", paymentType: "insurance" },
  { value: "kansas", label: "KANSAS CITY LIFE- HEALTHY CHOICES", paymentType: "insurance" },
  { value: "kps", label: "KPS Health Care", paymentType: "insurance" },
  { value: "liberty", label: "Liberty", paymentType: "insurance" },
  { value: "life", label: "LIFE MAP", paymentType: "insurance" },
  { value: "lifewise", label: "LIFEWISE", paymentType: "insurance" },
  { value: "lincoln", label: "Lincoln Financial", paymentType: "insurance" },
  { value: "line", label: "LineCo.", paymentType: "insurance" },
  { value: "metlife", label: "Metlife", paymentType: "insurance" },
  { value: "mutual", label: "Mutual of Omaha", paymentType: "insurance" },
  { value: "national", label: "National General", paymentType: "insurance" },
  { value: "neihb", label: "NEIHB Fund Office", paymentType: "insurance" },
  { value: "nippon", label: "Nippon Life Benefits", paymentType: "insurance" },
  { value: "nwadmin", label: "NORTHWEST ADMINISTRATORS", paymentType: "insurance" },
  { value: "nwiron", label: "NORTHWEST IRON WORKERS", paymentType: "insurance" },
  { value: "nwmetal", label: "Northwest Metal Crafts Trust Fund", paymentType: "insurance" },
  { value: "nwiam", label: "NW IAM", paymentType: "insurance" },
  { value: "planned", label: "Planned Administrators, Inc.", paymentType: "insurance" },
  { value: "premera", label: "PREMERA", paymentType: "insurance" },
  { value: "principal", label: "PRINCIPAL", paymentType: "insurance" },
  { value: "providence", label: "Providence Health Plan", paymentType: "insurance" },
  { value: "psew", label: "Puget Sound Electrical Workers Trust Fund", paymentType: "insurance" },
  { value: "pshc", label: "Puget Sound Health Care System", paymentType: "insurance" },
  { value: "regence", label: "REGENCE", paymentType: "insurance" },
  { value: "reliance", label: "Reliance Standard", paymentType: "insurance" },
  { value: "li", label: "L&I", paymentType: "insurance" },
  { value: "sun", label: "Sun Life Financial", paymentType: "insurance" },
  { value: "chickasaw", label: "The Chickasaw Nation Tribal Health", paymentType: "insurance" },
  { value: "standard", label: "The Standard Insurance", paymentType: "insurance" },
  { value: "tpsc", label: "TPSC", paymentType: "insurance" },
  { value: "tricare", label: "Tricare", paymentType: "insurance" },
  { value: "retiree", label: "Tricare Retiree Dental Program", paymentType: "insurance" },
  { value: "triwest", label: "Triwest/DD of CA", paymentType: "insurance" },
  { value: "trusted", label: "Trusteed Plans Service Co", paymentType: "insurance" },
  { value: "umr", label: "UMR", paymentType: "insurance" },
  { value: "concordia", label: "United Concordia", paymentType: "insurance" },
  { value: "empolye", label: "United Employees Benefit Trust", paymentType: "insurance" },
  { value: "health", label: "United Healthcare", paymentType: "insurance" },
  { value: "omaha", label: "United of Omaha", paymentType: "insurance" },
  { value: "unum", label: "UNUM DENTAL", paymentType: "insurance" },
  { value: "welfare", label: "WELFARE AND PENSION ADMINISTRATION", paymentType: "insurance" },
  { value: "zenith", label: "ZENITH", paymentType: "insurance" },
  { value: "zaal", label: "Zenith American/Area Local 52", paymentType: "insurance" },
  { value: "stripe", label: "Stripe", paymentType: "direct" },
];

export const DowntownInsuranceOptions: Array<PaymentOption> = [
  { value: "no-insurance", label: "No Insurance", paymentType: "insurance" },
  ...InsuranceOptions,
];

export const PaymentOptions: Array<PaymentOption> = [
  { value: "self", label: "I will pay myself", paymentType: "direct" },
  ...InsuranceOptions,
];

export const JamaicaInsuranceOptions: Array<PaymentOption> = [
  { value: "guardian", label: "Guardian Life Limited", paymentType: "insurance" },
  { value: "canopy", label: "Canopy Health Network", paymentType: "insurance" },
  { value: "sagicor", label: "SAGICOR Life Limited", paymentType: "insurance" },
];

export const ReferralSourceOptions = [
  { value: "google", label: "Google" },
  { value: "instagram", label: "Instagram" },
  { value: "facebook", label: "Facebook" },
  { value: "sign", label: "Sign/Billboard" },
  { value: "other", label: "Referral" },
];
